import { cva } from 'class-variance-authority';

export const cvaIcon = cva(['IconStyles-cvaIcon'], {
  variants: {
    iconSize: {
      common: ['w-2.4 h-2.4'],
      secondary: ['w-2.4 h-2.8'],
      third: ['w-3.6 h-2.4'],
    },
  },
});
